import React from 'react'

import Link from '@mui/material/Link'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'

// helpers
import { displayPlanDaysRemaining } from 'lib/helpers/account/plans'

// components
import LocationOpenDates from 'components/shared/LocationOpenDates'
import Cell from 'components/atoms/StyledTableCell'
import { useAppSettings } from 'components/shared/SettingsProvider'
import SoftCloseRestrictionNotice from './SoftCloseRestrictionNotice'

const DesktopPlanList = props => {
  const { plans, enableCovidRequirements } = props
  const { enableReservationsByDay } = useAppSettings()

  // don't show location dates if covid requirements are enabled
  // (in order to reduce confusion vs reserved week dates)
  const cells = enableCovidRequirements ? 5 : 6

  return (
    <Table size='small'>
      <TableHead>
        <TableRow>
          <Cell width={1 / cells}>Camp Session</Cell>
          <Cell width={1 / cells}>Product</Cell>
          <Cell width={1 / cells}>Days Remaining</Cell>
          <Cell width={1 / cells}>Days Used</Cell>
          <Cell width={1 / cells}>
            {enableReservationsByDay ? 'Location' : 'Preferred Location'}
          </Cell>
          {!enableCovidRequirements && <Cell width={1 / cells}>Dates</Cell>}
        </TableRow>
      </TableHead>
      <TableBody>
        {plans.map(plan => (
          <React.Fragment key={plan.id}>
            <TableRow>
              <Cell>{plan.session.name}</Cell>
              <Cell>{plan.product.description}</Cell>
              <Cell>{displayPlanDaysRemaining(plan, { label: false })}</Cell>
              <Cell>{plan.days.debited}</Cell>
              <Cell>
                <Link underline='always' href={plan.location.marcomUrl}>
                  {plan.location.name}
                </Link>
              </Cell>
              {!enableCovidRequirements && (
                <Cell>
                  <LocationOpenDates
                    openDate={plan.location.openDate}
                    closeDate={plan.location.closeDate}
                  />
                </Cell>
              )}
            </TableRow>
            {plan.softCloseRestriction && (
              <TableRow>
                <Cell colSpan={cells}>
                  <SoftCloseRestrictionNotice
                    restriction={plan.softCloseRestriction}
                    sessionId={plan.session.id}
                    registeredAt={plan.registeredAt}
                  />
                </Cell>
              </TableRow>
            )}
          </React.Fragment>
        ))}
      </TableBody>
    </Table>
  )
}

export default DesktopPlanList
